import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import {
  AgrNotificationEmptyModule,
  AgrSummaryCardHorizontalModule,
} from '@next/core-lib/components';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';
import { AgrPowerBiEmbeddedModule } from '@next/core-lib/powerbi-embedded';
import { AgrSharedModule } from '@next/core-lib/shared';
import { AgrTableModule } from '@next/core-lib/table';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { CowDetailsComponent } from './components/cow-details/cow-details.component';
import { CowDetailsDialogComponent } from './components/cow-details-dialog/cow-details-dialog.component';
import { DrillCowListComponent } from './components/drill-cow-list/drill-cow-list.component';
import { MonthPickerComponent } from './components/month-picker/month-picker.component';
import { ProductionPickerComponent } from './components/production-picker/production-picker.component';
import { CowEffects } from './store/effects/cow.effects';
import { ProductionEffects } from './store/effects/production.effects';
import { cowReducer } from './store/reducers/cow.reducers';
import { productionReducer } from './store/reducers/production.reducers';

@NgModule({
  imports: [
    AgrDialogModule,
    AgrSharedModule,
    AgrTableModule,
    AgrFormModule,
    AgrNotificationEmptyModule,
    MatTableModule,
    MatButtonModule,
    MatDatepickerModule,
    AgrSummaryCardHorizontalModule,
    MatExpansionModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSlideToggleModule,
    AgrPowerBiEmbeddedModule,
    CowDetailsComponent,
    CowDetailsDialogComponent,
    DrillCowListComponent,
    MonthPickerComponent,
    ProductionPickerComponent,
  ],
  exports: [
    AgrSharedModule,
    AgrPowerBiEmbeddedModule,
    ProductionPickerComponent,
    CowDetailsDialogComponent,
    MonthPickerComponent,
  ],
  providers: [
    provideState('production-shared', productionReducer),
    provideState('cow-shared', cowReducer),
    provideEffects([ProductionEffects, CowEffects]),
    // add shared services and guards here
    // ApiService,
  ],
})
export class SharedModule {}
